import {
  UPLOAD_GALLRY_IMAGE_REQUEST,
  UPLOAD_GALLRY_IMAGE_SUCCESS,
  UPLOAD_GALLRY_IMAGE_FAILURE,
} from "../../../Utils/Constant";

const initialState = {
  data: {},
  loading: false,
  error: null,
};
export const uploadGalleryImageReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case UPLOAD_GALLRY_IMAGE_REQUEST:
      return {
        ...state,
        data: action.payload,
        loading: true,
        error: null,
      };
    case UPLOAD_GALLRY_IMAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case UPLOAD_GALLRY_IMAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
